<template>
    <div style="padding: 20px">
        <Tabs value="name1">
            <TabPane label="针式打印机纸张选择" name="name1" style="padding: 20px">
                <RadioGroup v-model="radios">
                    <Alert><Radio label="1">50*30</Radio> </Alert>
                    <Alert><Radio label="2">40*30</Radio></Alert>
                </RadioGroup>
            </TabPane>
        </Tabs>
    </div>
</template>
<script>
    export default {
        components: {},
        data () {
            return {
                cid:"",
                radios:'2'
            }
        },
        mounted: function() {
            //DOM更新完后再请求数据
            this.$nextTick(function() {

            });
        },
        created: function() {
            //DOM更新完之前请求数据

        },
        methods: {


        }
    }
</script>


<style  lang="scss" scoped>
    .server-title{
        display: inline-block;
        text-align: center;width: 88%
    }
    .logo{
        width: 50px;
        height: 50px;
        margin: auto;
    }
    .ivu-form-item{
        height: 30px;
    }
</style>